<!-- Menu Lateral -->
<app-side-menu></app-side-menu>

<!-- Header -->
<app-topbar></app-topbar>

<!-- Router Link -->
<router-outlet></router-outlet>